module.exports = __webpack_public_path__ + "static/heroMobile@x1-ba2150ce51be9fa290bfef7fe3f53055.png";